import ForgotPasswordModal from './ForgotPasswordModal';
export default ForgotPasswordModal;
